/* 🤖 this file was generated by svg-to-ts */
export const iconStar: {
    name: 'star';
    data: string;
} = {
    name: 'star',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20"><path fill="#000" fill-rule="evenodd" d="m7.608 6.292-6.279.914-.096.021a.65.65 0 0 0-.264 1.088l4.543 4.427-1.072 6.256-.01.092a.65.65 0 0 0 .953.593L11 16.729l5.616 2.954.085.037a.65.65 0 0 0 .858-.722l-1.072-6.256 4.544-4.427.065-.073a.65.65 0 0 0-.425-1.036l-6.28-.914L11.583.603a.65.65 0 0 0-1.166 0zM11 2.358l2.377 4.817.054.09a.65.65 0 0 0 .435.265l5.314.772-3.845 3.749-.07.08a.65.65 0 0 0-.117.495l.906 5.292-4.752-2.498-.097-.041a.65.65 0 0 0-.507.041l-4.754 2.498.908-5.292.01-.105a.65.65 0 0 0-.197-.47L2.819 8.302l5.315-.772a.65.65 0 0 0 .49-.355z"/></svg>`
};
